(() => {
'use strict';
const ROOT='[data-sh-inline-size-finder]';
const ALPHA=['XS','S','M','L','XL'];
const SIZE_LABEL={XS:'FR36',S:'FR38',M:'FR40',L:'FR42',XL:'FR44'};
const LIMITS=[76,79,81,85];
const USUAL={
  men:{'36':'XS','38':'S','40':'M','42':'L','44':'XL','46':'XL','48':'XL'},
  women:{'34':'XS','36':'S','38':'M','40':'L','42':'XL','44':'XL','46':'XL'}
};
const HEIGHT_RANGE={men:[165,181],women:[159,176]};
const COPY={
 fr:{
  measured:'Le {size} est conseillé pour un tour de taille de {waist} cm.',
  usual:'Le {size} est conseillé à partir de votre taille de pantalon habituelle.',
  near:'Votre mesure est proche d’une limite entre deux tailles. Le guide privilégie {size} pour éviter une ceinture trop serrée.',
  fallback:'Estimation basée sur votre taille de pantalon habituelle {usual}. Pour plus de précision, utilisez votre tour de taille mesuré.',
  longer:'À votre stature, le pantalon pourra tomber légèrement plus long. L’entrejambe varie seulement de 75 à 76 cm selon les tailles.',
  shorter:'À votre stature, le pantalon pourra tomber légèrement plus court. L’entrejambe varie seulement de 75 à 76 cm selon les tailles.',
  max:'Même le FR44 dépasse la plage d’élasticité prudente pour cette mesure.',
  comfort:'Le FR44 est la plus grande taille disponible et la marge de confort standard ne peut pas être garantie.',
  xs:'Le FR36 est la plus petite taille disponible et peut rester ample à la ceinture.',
  alt:'{size} est indisponible dans cette couleur. {target} est l’alternative disponible la plus proche sans descendre vers une taille plus serrée.',
  noalt:'{size} est indisponible dans cette couleur et aucune taille supérieure disponible ne respecte la recommandation.',
  select:'SÉLECTIONNER {size}',picker:'Utilisez le sélecteur de tailles au-dessus pour choisir la taille recommandée.',
  selected:'{size} sélectionné.',notfound:'La taille recommandée n’a pas été trouvée dans le sélecteur de tailles.'
 },
 en:{
  measured:'{size} is recommended for a waist circumference of {waist} cm.',
  usual:'{size} is recommended based on your usual trouser size.',
  near:'Your measurement is close to the boundary between two sizes. The guide favors {size} to avoid a waistband that feels too tight.',
  fallback:'Estimate based on your usual trouser size {usual}. For greater accuracy, use your measured waist circumference.',
  longer:'At your height, the trousers may fall slightly longer. The inseam only varies from 75 to 76 cm across sizes.',
  shorter:'At your height, the trousers may fall slightly shorter. The inseam only varies from 75 to 76 cm across sizes.',
  max:'Even FR44 is beyond the cautious stretch range for this measurement.',
  comfort:'FR44 is the largest available size and the standard comfort margin cannot be guaranteed.',
  xs:'FR36 is the smallest available size and may still fit loose at the waist.',
  alt:'{size} is unavailable in this color. {target} is the closest available alternative without sizing down to a tighter waistband.',
  noalt:'{size} is unavailable in this color and no larger available size meets the recommendation.',
  select:'SELECT {size}',picker:'Use the size selector above to choose the recommended size.',
  selected:'{size} selected.',notfound:'The recommended size could not be found in the size selector.'
 },
 nl:{
  measured:'{size} wordt aanbevolen voor een tailleomtrek van {waist} cm.',
  usual:'{size} wordt aanbevolen op basis van je gebruikelijke broekmaat.',
  near:'Je meting ligt dicht bij de grens tussen twee maten. De gids kiest {size} om een te strakke tailleband te vermijden.',
  fallback:'Schatting op basis van je gebruikelijke broekmaat {usual}. Voor meer nauwkeurigheid gebruik je je gemeten tailleomtrek.',
  longer:'Bij jouw lengte kan de broek iets langer vallen. De binnenbeenlengte varieert slechts van 75 tot 76 cm tussen de maten.',
  shorter:'Bij jouw lengte kan de broek iets korter vallen. De binnenbeenlengte varieert slechts van 75 tot 76 cm tussen de maten.',
  max:'Zelfs FR44 valt buiten de voorzichtige rekzone voor deze meting.',
  comfort:'FR44 is de grootste beschikbare maat en de standaard comfortmarge kan niet worden gegarandeerd.',
  xs:'FR36 is de kleinste beschikbare maat en kan nog ruim vallen aan de taille.',
  alt:'{size} is niet beschikbaar in deze kleur. {target} is het dichtstbijzijnde beschikbare alternatief zonder naar een strakkere maat te gaan.',
  noalt:'{size} is niet beschikbaar in deze kleur en er is geen grotere beschikbare maat die aan de aanbeveling voldoet.',
  select:'KIES {size}',picker:'Gebruik de maatkeuze hierboven om de aanbevolen maat te selecteren.',
  selected:'{size} geselecteerd.',notfound:'De aanbevolen maat werd niet gevonden in de maatkeuze.'
 }
};
const bound=new WeakSet(),cache=new WeakMap();
const q=(r,n)=>r.querySelector(`[data-sh-${n}]`);
const audience=r=>r.dataset.shAudience==='women'?'women':'men';
const language=r=>{const x=String(r.dataset.shLang||'en').slice(0,2).toLowerCase();return COPY[x]?x:'en'};
const tr=(r,k,v={})=>(COPY[language(r)][k]||COPY.en[k]||k).replace(/\{(\w+)\}/g,(_,x)=>String(v[x]??''));
const num=e=>{if(!e)return NaN;const x=String(e.value??'').trim().replace(',','.');return x===''?NaN:Number(x)};
const alphaFromWaist=w=>w<76?'XS':w<79?'S':w<81?'M':w<85?'L':'XL';
const label=s=>SIZE_LABEL[s]||s;
const norm=s=>String(s??'').trim().toLocaleLowerCase();
const text=(e,s)=>{if(e){e.textContent=s||'';e.hidden=!s}};
const error=(r,n,on)=>{const e=r.querySelector(`[data-sh-error="${n}"]`);if(e)e.hidden=!on};
const hideResult=(r,on)=>{const e=q(r,'result');if(e)e.hidden=on};
function variants(r){
 if(cache.has(r))return cache.get(r);
 let a=[];try{a=JSON.parse(q(r,'variants')?.textContent||'[]');if(!Array.isArray(a))a=[]}catch{}
 cache.set(r,a);return a;
}
function picker(r){
 const p=r.previousElementSibling;if(p?.matches('variant-picker'))return p;
 const sec=r.closest('.shopify-section');if(!sec)return null;const id=String(r.dataset.shProductId||'');
 return [...sec.querySelectorAll('variant-picker')].find(x=>{const y=String(x.dataset.productId||'');return!id||!y||y===id})||null;
}
function currentColor(r){
 const p=picker(r);if(!p)return '';
 const checked=p.querySelector('fieldset[data-fieldset-index="0"] input:checked');
 if(checked)return String(checked.value||'').trim();
 const firstSelect=p.querySelector('select');
 return firstSelect?String(firstSelect.value||'').trim():'';
}
function optionsOf(v){
 if(Array.isArray(v?.options))return v.options;
 return [v?.option1,v?.option2,v?.option3].filter(x=>x!=null);
}
function findVariant(r,s){
 const wanted=label(s),color=currentColor(r),all=variants(r);
 const exact=all.find(v=>{const o=optionsOf(v);return norm(o[1])===norm(wanted)&&(!color||norm(o[0])===norm(color))});
 return exact||all.find(v=>{const o=optionsOf(v);return norm(o[1])===norm(wanted)})||null;
}
function reveal(r,focus=false){
 const e=q(r,'height'),h=num(e),ok=Number.isFinite(h)&&h>=140&&h<=220;
 error(r,'height',String(e?.value??'').trim()!==''&&!ok);if(!ok)return false;
 const d=q(r,'details');if(d)d.hidden=false;
 const p=q(r,'height-prompt');if(p)p.textContent=`${Math.round(h)} cm`;
 if(focus)(r.dataset.shWaistMode==='usual'?q(r,'usual-size'):q(r,'waist'))?.focus({preventScroll:true});
 return true;
}
function render(r,s,w,u,h){
 const recommended=label(s),sn=q(r,'size'),cp=q(r,'result-copy');if(sn)sn.textContent=recommended;
 if(cp)cp.textContent=w!==null?tr(r,'measured',{size:recommended,waist:Math.round(w*10)/10}):tr(r,'usual',{size:recommended});
 text(q(r,'alternative'),w!==null&&LIMITS.some(x=>Math.abs(w-x)<=.5)?tr(r,'near',{size:recommended}):'');
 text(q(r,'fallback-note'),u?tr(r,'fallback',{usual:u}):'');
 const range=HEIGHT_RANGE[audience(r)];text(q(r,'length-note'),range&&h<range[0]?tr(r,'longer'):range&&h>range[1]?tr(r,'shorter'):'');
 text(q(r,'caution'),w!==null&&w>98?tr(r,'max'):w!==null&&w>93?tr(r,'comfort'):w!==null&&w<65?tr(r,'xs'):'');
 const b=q(r,'select'),st=q(r,'stock');if(b){b.hidden=true;b.disabled=false;b.removeAttribute('data-sh-target')}text(st,'');
 let target=s,v=findVariant(r,s),i=ALPHA.indexOf(s);
 if(!v?.available){
  target=null;
  for(let x=i+1;x<ALPHA.length;x++){const c=findVariant(r,ALPHA[x]);if(c?.available){target=ALPHA[x];v=c;break}}
  text(st,target?tr(r,'alt',{size:recommended,target:label(target)}):tr(r,'noalt',{size:recommended}));
 }
 if(target&&v?.available&&b){b.hidden=false;b.dataset.shTarget=target;b.textContent=tr(r,'select',{size:label(target)})}
 r.dataset.shFinderVersion='fr-variants-v2';hideResult(r,false);
}
function calc(r){
 const h=num(q(r,'height'));if(!Number.isFinite(h)||h<140||h>220){error(r,'height',true);hideResult(r,true);return}
 error(r,'height',false);reveal(r);
 let w=null,u=null,s=null;
 if(r.dataset.shWaistMode==='usual'){
  const e=q(r,'usual-size'),v=e?.value||'';u=e?.selectedOptions?.[0]?.textContent?.trim()||v;s=USUAL[audience(r)]?.[v]||null;
  if(!s){error(r,'usual',true);hideResult(r,true);return}error(r,'usual',false);
 }else{
  w=num(q(r,'waist'));if(!Number.isFinite(w)||w<55||w>120){error(r,'waist',true);hideResult(r,true);return}
  error(r,'waist',false);s=alphaFromWaist(w);
 }
 render(r,s,w,u,h);
}
function mode(r,m){
 const usual=m==='usual';r.dataset.shWaistMode=usual?'usual':'waist';
 const wb=q(r,'waist-block'),ub=q(r,'usual-block');if(wb)wb.hidden=usual;if(ub)ub.hidden=!usual;
 error(r,'waist',false);error(r,'usual',false);hideResult(r,true);
}
function choose(r){
 const b=q(r,'select'),s=b?.dataset.shTarget;if(!s)return;const p=picker(r),wanted=label(s);
 if(!p){text(q(r,'stock'),tr(r,'picker'));return}
 const sizeFieldset=p.querySelector('fieldset[data-fieldset-index="1"]')||p.querySelectorAll('fieldset')[1];
 const radio=sizeFieldset?[...sizeFieldset.querySelectorAll('input[type="radio"]')].find(x=>norm(x.value)===norm(wanted)):null;
 if(radio){radio.click();text(q(r,'stock'),tr(r,'selected',{size:wanted}));return}
 const selects=[...p.querySelectorAll('select')],sizeSelect=selects[1]||selects.find(s=>String(s.name||'').toLowerCase().includes('taille'));
 const o=sizeSelect?[...sizeSelect.options].find(x=>norm(x.value)===norm(wanted)):null;
 if(o&&sizeSelect){sizeSelect.value=o.value;sizeSelect.dispatchEvent(new Event('change',{bubbles:true}));text(q(r,'stock'),tr(r,'selected',{size:wanted}));return}
 text(q(r,'stock'),tr(r,'notfound'));
}
function bind(r){
 if(bound.has(r))return;bound.add(r);r.dataset.shFinderVersion='fr-variants-v2';
 q(r,'height-next')?.addEventListener('click',e=>{e.preventDefault();reveal(r,true)});
 q(r,'waist-unknown')?.addEventListener('click',e=>{e.preventDefault();mode(r,'usual');q(r,'usual-size')?.focus({preventScroll:true})});
 q(r,'waist-known')?.addEventListener('click',e=>{e.preventDefault();mode(r,'waist');q(r,'waist')?.focus({preventScroll:true})});
 q(r,'calculate')?.addEventListener('click',e=>{e.preventDefault();calc(r)});
 q(r,'select')?.addEventListener('click',e=>{e.preventDefault();choose(r)});
 q(r,'edit')?.addEventListener('click',e=>{e.preventDefault();hideResult(r,true);q(r,'height')?.focus({preventScroll:true})});
 q(r,'height')?.addEventListener('input',()=>{hideResult(r,true);reveal(r)});
 q(r,'waist')?.addEventListener('input',()=>{error(r,'waist',false);hideResult(r,true)});
 q(r,'usual-size')?.addEventListener('change',()=>{error(r,'usual',false);hideResult(r,true)});
 q(r,'height')?.addEventListener('keydown',e=>{if(e.key==='Enter'){e.preventDefault();reveal(r,true)}});
 q(r,'waist')?.addEventListener('keydown',e=>{if(e.key==='Enter'){e.preventDefault();calc(r)}});
 q(r,'usual-size')?.addEventListener('keydown',e=>{if(e.key==='Enter'){e.preventDefault();calc(r)}});
}
function init(scope=document){if(scope.matches?.(ROOT))bind(scope);scope.querySelectorAll?.(ROOT).forEach(bind)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(),{once:true});else init();
document.addEventListener('shopify:section:load',e=>{if(e.target instanceof Element)init(e.target)});
document.addEventListener('variant:update',e=>{
 const section=e.target instanceof Element?e.target.closest('.shopify-section'):null;
 (section||document).querySelectorAll(ROOT).forEach(r=>{if(!q(r,'result')?.hidden)calc(r)});
});
})();
